export interface DocumentSection {
  id: string;
  title: string;
  subsections: DocumentSubsection[];
}

export interface DocumentSubsection {
  id: string;
  title: string;
  filePath: string;
}

export const documentTitles = {
  ko: {
    'overview': '개요',
    'overview-main': 'SDK 소개',
    'architecture': '아키텍처',
    'getting-started': '시작하기',
    'system-requirements': '시스템 요구사항',
    'installation': '설치 및 설정',
    'first-connection': '첫 번째 연결',
    'ble-protocol': 'BLE 프로토콜',
    'services-uuids': '서비스 UUID',
    'packet-structure': '패킷 구조',
    'timestamps': '타임스탬프',
    'sampling-rates': '샘플링 레이트',
    'api-reference': 'SDK API',
    'bluetooth-service': 'BluetoothService',
    'stream-processor': 'StreamProcessor',
    'session-manager': 'SessionManager',
    'stores': '상태 관리 (Stores)',
    'data-guide': '데이터 가이드',
    'eeg-data': 'EEG 데이터',
    'ppg-data': 'PPG 데이터',
    'acc-data': 'ACC 데이터',
    'export-formats': '내보내기 포맷',
    'interface': '인터페이스',
    'dashboard': 'Dashboard',
    'device-manager': 'Device Manager',
    'visualizer': 'Visualizer',
    'data-center': 'Data Center',
  },
  en: {
    'overview': 'Overview',
    'overview-main': 'SDK Introduction',
    'architecture': 'Architecture',
    'getting-started': 'Getting Started',
    'system-requirements': 'System Requirements',
    'installation': 'Installation & Setup',
    'first-connection': 'First Connection',
    'ble-protocol': 'BLE Protocol',
    'services-uuids': 'Service UUIDs',
    'packet-structure': 'Packet Structure',
    'timestamps': 'Timestamps',
    'sampling-rates': 'Sampling Rates',
    'api-reference': 'SDK API',
    'bluetooth-service': 'BluetoothService',
    'stream-processor': 'StreamProcessor',
    'session-manager': 'SessionManager',
    'stores': 'State Management (Stores)',
    'data-guide': 'Data Guide',
    'eeg-data': 'EEG Data',
    'ppg-data': 'PPG Data',
    'acc-data': 'ACC Data',
    'export-formats': 'Export Formats',
    'interface': 'Interface',
    'dashboard': 'Dashboard',
    'device-manager': 'Device Manager',
    'visualizer': 'Visualizer',
    'data-center': 'Data Center',
  }
};

export type DocLanguage = keyof typeof documentTitles;

export function getDocumentStructure(language: DocLanguage): DocumentSection[] {
  const titles = documentTitles[language];
  return [
    {
      id: 'overview',
      title: titles['overview'],
      subsections: [
        { id: 'overview', title: titles['overview-main'], filePath: 'overview/overview.md' },
        { id: 'architecture', title: titles['architecture'], filePath: 'overview/architecture.md' },
      ]
    },
    {
      id: 'getting-started',
      title: titles['getting-started'],
      subsections: [
        { id: 'system-requirements', title: titles['system-requirements'], filePath: 'getting-started/system-requirements.md' },
        { id: 'installation', title: titles['installation'], filePath: 'getting-started/installation.md' },
        { id: 'first-connection', title: titles['first-connection'], filePath: 'getting-started/first-connection.md' },
      ]
    },
    {
      id: 'ble-protocol',
      title: titles['ble-protocol'],
      subsections: [
        { id: 'services-uuids', title: titles['services-uuids'], filePath: 'ble-protocol/services-uuids.md' },
        { id: 'packet-structure', title: titles['packet-structure'], filePath: 'ble-protocol/packet-structure.md' },
        { id: 'timestamps', title: titles['timestamps'], filePath: 'ble-protocol/timestamps.md' },
        { id: 'sampling-rates', title: titles['sampling-rates'], filePath: 'ble-protocol/sampling-rates.md' },
      ]
    },
    {
      id: 'api-reference',
      title: titles['api-reference'],
      subsections: [
        { id: 'bluetooth-service', title: titles['bluetooth-service'], filePath: 'api-reference/bluetooth-service.md' },
        { id: 'stream-processor', title: titles['stream-processor'], filePath: 'api-reference/stream-processor.md' },
        { id: 'session-manager', title: titles['session-manager'], filePath: 'api-reference/session-manager.md' },
        { id: 'stores', title: titles['stores'], filePath: 'api-reference/stores.md' },
      ]
    },
    {
      id: 'data-guide',
      title: titles['data-guide'],
      subsections: [
        { id: 'eeg-data', title: titles['eeg-data'], filePath: 'data-guide/eeg-data.md' },
        { id: 'ppg-data', title: titles['ppg-data'], filePath: 'data-guide/ppg-data.md' },
        { id: 'acc-data', title: titles['acc-data'], filePath: 'data-guide/acc-data.md' },
        { id: 'export-formats', title: titles['export-formats'], filePath: 'data-guide/export-formats.md' },
      ]
    },
    {
      id: 'interface',
      title: titles['interface'],
      subsections: [
        { id: 'dashboard', title: titles['dashboard'], filePath: 'interface/dashboard.md' },
        { id: 'device-manager', title: titles['device-manager'], filePath: 'interface/device-manager.md' },
        { id: 'visualizer', title: titles['visualizer'], filePath: 'interface/visualizer.md' },
        { id: 'data-center', title: titles['data-center'], filePath: 'interface/data-center.md' },
      ]
    },
  ];
}
